import { useCallback } from 'react';
import { useAnalyticsConfiguration } from 'shared/hooks/analytics/useAnalyticsConfiguration';

export const useApplicationTrackErrorEvents = () => {
  const { segmentClient } = useAnalyticsConfiguration();

  const logErrorEvent = useCallback(
    (error_message: string, source_name: string): void => {
      void segmentClient.logEvent('Application Flow Error Encountered', {
        category: 'application',
        subcategory: 'checking',
        error_message: error_message,
        source_name: source_name,
        ...(source_name.includes('reactivation') && {
          reactivation_flow: 'true',
        }),
      });
    },
    [segmentClient],
  );

  return { logErrorEvent };
};

export enum SourceName {
  SIGNUP_PAGE = 'signup_page',
  PHONE_VERIFICATION = 'phone_number_verification',
  EMAIL_VERIFICATION = 'email_verification',
  PERSONAL_INFORMATION = 'personal_info_name',
  ADDRESS_VERIFICATION = 'personal_info_address',
  DOB = 'personal_info_dob',
  SSN_VERIFICATION = 'ssn_verification',
  CITIZENSHIP = 'citizenship',
  EMPLOYMENT = 'employment',
  LEGAL_AGREEMENT = 'legal_agreements',
  APPLICATION_DECISION = 'application_decision',
  SOCURE = 'socure',
  EDD_QUESTIONS = 'edd_questions',
  REACTIVATION = 'reactivation',
  REACTIVATION_PERSONAL_INFO = 'reactivation_personal_info',
  REACTIVATION_LEGAL_AGREEMENTS = 'reactivation_legal_agreements',
  REACTIVATION_DOB = 'reactivation_personal_info_dob',
  REACTIVATION_EMPLOYMENT = 'reactivation_personal_info_employment',
  REACTIVATION_ADDRESS_VERIFICATION = 'reactivation_personal_info_address',
  REACTIVATION_CITIZENSHIP = 'reactivation_personal_info_citizenship',
}
